import PropTypes from 'prop-types';
import React from 'react';

import SUMMARY_PACKAGE_RENDERERS from '~pricing/lib/summaryPackages';
import { packageLabelToClassName } from '~pricing/lib/helpers';
import { PackagePropTypes, RibbonTextOverridePropType } from '~pricing/lib/proptypes';

import './package.scss';

const Package = ({
  details,
  skuCost,
  package: packageName,
  packageRenderers = SUMMARY_PACKAGE_RENDERERS,
  ribbonText = null,
}) => {
  const packageClassName = packageLabelToClassName(details);
  const {
    summary: { features, headerRenderer: PackageHeader, footerRenderer: PackageFooter },
  } = packageRenderers[packageName];

  // Filter out any hidden features. This is the opportunity for an
  // indvidual feature to remove itself from the feature list via
  // whatever logic
  const visibleFeatures = features.filter(feature => !feature.hidden);

  return (
    <article className={`sm-package sm-package--border-${packageClassName}`} key={packageName} data-testid="Package">
      <section className="sm-package__details">
        <PackageHeader skuCosts={skuCost} details={details} packageName={packageName} ribbonText={ribbonText} />
        <ul className="sm-package__feature-list">
          {visibleFeatures.map(feature => {
            return (
              <li className="sm-package__feature" key={`${packageName}-feature-${feature.summaryLine}`}>
                {feature.summaryLine}
              </li>
            );
          })}
        </ul>
      </section>
      <footer className="sm-package__footer">
        <PackageFooter packageName={packageName} packageClassName={packageClassName} />
      </footer>
    </article>
  );
};

Package.propTypes = {
  ...PackagePropTypes,
  packageRenderers: PropTypes.objectOf(
    PropTypes.shape({
      summary: PropTypes.shape({
        headerRenderer: PropTypes.func.isRequired,
        footerRenderer: PropTypes.func.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        features: PropTypes.array.isRequired,
      }),
    })
  ),
  ribbonText: RibbonTextOverridePropType,
};

Package.defaultProps = {
  packageRenderers: SUMMARY_PACKAGE_RENDERERS,
  ribbonText: null,
};

export default Package;
